// 响应式
import chartResize from "./mixins/chartResize"
// echarts 部分配置mixin
import echartCommon from "./mixins/echart"
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core"

require("echarts/theme/macarons")
export { chartResize, echarts, echartCommon }
const colors = ["#5470c6", "#91cc75", "#fac858", "#ee6666", "#73c0de", "#3ba272", "#fc8452", "#9a60b4", "#ea7ccc"]

export const COLOR_LIST = colors
